module.exports = __webpack_public_path__ + "img/resimple_card.9ebe00d8.png";